import type { Entity } from '@backstage/catalog-model';

const isPartner = (e: Entity) => e.kind === 'Resource' && e.spec?.type === 'partner';

/**
 * Onglet « Déploiements » d'ArgoCD : affiché quand la fiche déclare ses
 * applications (même règle que le plugin), sauf pour les partenaires, dont la
 * vue d'ensemble porte une carte Déploiements tous environnements confondus.
 */
export function showArgocdDeploymentsTab(entity: Entity): boolean {
  const a = entity.metadata.annotations ?? {};
  const configured = Boolean(a['platform.io/argocd-app-prefix'] || a['argocd/app-name']);
  return configured && !isPartner(entity);
}
